import './components/base';
import './components/form';
import './components/swiper';

var mainNav = document.getElementById("main-nav");
var toggleNavBtn = document.getElementById("burger-toggle");
var closeNavBtn = document.getElementById("burger-close");
var pointDown = document.getElementById("point-down");
var contactButton = document.getElementById("contact-button");

// Ouvrir le menu responsive
function openNav(){
    mainNav.classList.add("active");
    document.body.classList.add("active");
    pointDown.classList.add("not-clickable");
    contactButton.classList.add("not-clickable");
}

// Fermer le menu responsive
function closeNav(){
    mainNav.classList.remove("active");
    document.body.classList.remove("active");
    pointDown.classList.remove("not-clickable");
    contactButton.classList.remove("not-clickable");
}

// Gérer l'événement d'ouvrir/fermer le menu
toggleNavBtn.addEventListener("click", openNav);
closeNavBtn.addEventListener("click", closeNav);

window.addEventListener('resize', function(){
    if(window.innerWidth >= 984 && document.body.classList.contains('active')){
        closeNav();
    }
})

// Obtention des liens de la barre de navigation
var navLinks = mainNav.querySelectorAll("a");

navLinks.forEach(function(link){
    link.addEventListener("click", function(e){
        // Récupère la cible du lien
        var targetId = this.getAttribute("href");
        var targetElement = document.querySelector(targetId);
        
        if(targetElement){
            closeNav();
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }

        e.preventDefault();
    })
})

// Ajout de contenu variable dans les ::before et ::after de l'image dans les 3 colonnes
document.addEventListener("DOMContentLoaded", function(){
    if(document.getElementById("sport")){
        var sportDiv = document.getElementById("sport");
        var textContent = sportDiv.textContent || sportDiv.innerText;
    
        sportDiv.style.setProperty("--sport-content", "'" + textContent + "'");
    }
})